export const xor64 = (a, b) => [a[0] ^ b[0], a[1] ^ b[1]];
